<template>
  <div class="container">
    <div class="home" v-if="role=='1'">
      <van-search
              v-model="searchWord"
              show-action
              shape="round"
              placeholder="搜索"
              background="#295ED5"
              @focus="toSearch"
              action-text="X"
              @cancel="closeFn"
      />
      <div class="banner">
        <img src="../assets/images/banner.png" alt="">
      </div>
      <div class="orderBox">
        <div class="orderItem">
          <div class="topTitle flexBetween">
            <div class="title">代购订单</div>
            <div class="toCont" @click="toOrderList(0)">全部订单 ></div>
          </div>
          <div class="orderList flexLeft">
            <div class="item" @click="toOrderList(0,1)">
              <img src="../assets/images/dqr.png" alt=""><br>待确认
              <div class="num" v-if="dgOrderNum.confirm_num>0">{{dgOrderNum.confirm_num}}</div>
            </div>
            <div class="item" @click="toOrderList(0,2)">
              <img src="../assets/images/dgm.png" alt=""><br>待购买
              <div class="num" v-if="dgOrderNum.buy_num>0">{{dgOrderNum.buy_num}}</div>
            </div>
            <div class="item" @click="toOrderList(0,3)">
              <img src="../assets/images/dps.png" alt=""><br>待配送
              <div class="num" v-if="dgOrderNum.delivery_num>0">{{dgOrderNum.delivery_num}}</div>
            </div>
            <div class="item" @click="toOrderList(0,4)">
              <img src="../assets/images/ywc.png" alt=""><br>已完成
              <div class="num" v-if="dgOrderNum.finish_num>0">{{dgOrderNum.finish_num}}</div>
            </div>
            <div class="item" @click="toOrderList(0,5)">
              <img src="../assets/images/yjj.png" alt=""><br>已取消
              <div class="num" v-if="dgOrderNum.cancel_num>0">{{dgOrderNum.cancel_num}}</div>
            </div>
          </div>
        </div>

        <div class="orderItem">
          <div class="topTitle flexBetween">
            <div class="title">取件订单</div>
            <div class="toCont" @click="toOrderList(1)">全部订单 ></div>
          </div>
          <div class="orderList flexLeft">
            <div class="item" @click="toOrderList(1,1)">
              <img src="../assets/images/dqr.png" alt=""><br>待确认
              <div class="num" v-if="qjOrderNum.confirm_num>0">{{qjOrderNum.confirm_num}}</div>
            </div>
            <div class="item" @click="toOrderList(1,2)">
              <img src="../assets/images/dqj.png" alt=""><br>待取件
              <div class="num" v-if="qjOrderNum.buy_num>0">{{qjOrderNum.buy_num}}</div>
            </div>
            <div class="item" @click="toOrderList(1,3)">
              <img src="../assets/images/dps.png" alt=""><br>待配送
              <div class="num" v-if="qjOrderNum.delivery_num>0">{{qjOrderNum.delivery_num}}</div>
            </div>
            <div class="item" @click="toOrderList(1,4)">
              <img src="../assets/images/ywc.png" alt=""><br>已完成
              <div class="num" v-if="qjOrderNum.finish_num>0">{{qjOrderNum.finish_num}}</div>
            </div>
            <div class="item" @click="toOrderList(1,5)">
              <img src="../assets/images/yjj.png" alt=""><br>取件失败
              <div class="num" v-if="qjOrderNum.fail_num>0">{{qjOrderNum.fail_num}}</div>
            </div>
          </div>
        </div>
        <div class="orderItem">
          <div class="topTitle flexBetween">
            <div class="title">寄件订单</div>
            <div class="toCont" @click="toOrderList(2)">全部订单 ></div>
          </div>
          <div class="orderList flexLeft">
            <div class="item" @click="toOrderList(2,1)">
              <img src="../assets/images/dqj.png" alt=""><br>待取件
              <div class="num" v-if="jjOrderNum.confirm_num>0">{{jjOrderNum.confirm_num}}</div>
            </div>
            <div class="item" @click="toOrderList(2,2)">
              <img src="../assets/images/djj.png" alt=""><br>待寄件
              <div class="num" v-if="jjOrderNum.buy_num>0">{{jjOrderNum.buy_num}}</div>
            </div>
            <div class="item" @click="toOrderList(2,3)">
              <img src="../assets/images/ywc.png" alt=""><br>已完成
              <div class="num" v-if="jjOrderNum.finish_num>0">{{jjOrderNum.finish_num}}</div>
            </div>
<!--            <div class="item" @click="toOrderList(2,4)">-->
<!--              <img src="../assets/images/yqx.png" alt=""><br>已取消-->
<!--              <div class="num" v-if="jjOrderNum.finish_num>0">{{jjOrderNum.finish_num}}</div>-->
<!--            </div>-->
          </div>
        </div>
      </div>
    </div>
    <partnerHome v-if="role=='2'"></partnerHome>
  </div>
</template>

<script>
  import partnerHome from "./ddPartner/home";
  import Vue from 'vue';
  import {Search} from 'vant';
  Vue.use(Search);
  export default {
    name: "index",
    components:{
      partnerHome
    },
    data() {
      return {
        searchWord: '',
        dgOrderNum:{},//代购订单数量
        qjOrderNum:{},//取件
        jjOrderNum:{},//寄件
        role:''
      }
    },
    mounted(){
      this.getRole();
      this.getOrderNum();
    },
    methods: {
      // 调用安卓 ios 方法 退出商城
      closeFn(){
        if(window.hasOwnProperty('Android')){
          window.Android.closeWebView();
        }

        this.$bridge.callhandler('closureofMall',  {}, () => {
          // 处理返回数据
        });

      },
      //获取登录角色 1.物业 2.商业
      getRole(){
        this.role = window.localStorage.getItem('partner_type');
      },
      //获取订单相应数量
      getOrderNum(){
        //代购
        this.sendHttp({
          method:'post',
          url:`${this.orderUrl}/marketservice/countorder`,
          data:{}
        }).then(res=>{
          if(res.code=='0'){
            this.dgOrderNum = res.data;
          }
        });
        //取件
        this.sendHttp({
          method:'post',
          url:`${this.orderUrl}/marketexpressreceipt/countorder`,
          data:{}
        }).then(res=>{
          if(res.code=='0'){
            this.qjOrderNum = res.data;
          }
        });

        //寄件
        this.sendHttp({
          method:'post',
          url:`${this.orderUrl}/marketexpressdelivery/countorder`,
          data:{}
        }).then(res=>{
          if(res.code=='0'){
            this.jjOrderNum = res.data;
          }
        });

      },
      //跳转订单列表
      toOrderList(num,index=0){
        if(num===0){
          this.$router.push({
            path:'/dgOrder',
            query:{
              index:index
            }
          });
        }
        if(num===1){
          this.$router.push({
            path:'/qjOrder',
            query:{
              index:index
            }
          });
        }
        if(num===2){
          this.$router.push({
            path:'/jjOrder',
            query:{
              index:index
            }
          });
        }
      },
      //搜索框获取焦点
      toSearch() {
        this.$router.push('/search');
      },


    }
  }
</script>

<style scoped lang="less">
  .home {
    background: #f5f5f5;
    height: 100%;
    width: 100%;
    position: absolute;

    .orderBox {
      .orderItem {
        margin-top: 6px;

        .orderList {
          height: 77px;
          background: #fff;

          .item {
            width: 20%;
            text-align: center;
            font-size: 12px;
            color: #666;
            letter-spacing: 1px;
            position: relative;
            .num{
              position: absolute;
              top: -5px;
              right: 5px;
              text-align: center;
              min-width: 18px;
              line-height: 18px;
              border-radius: 40%;
              background: red;
              color: #fff;
              box-sizing: border-box;
              padding: 0 5px;
            }

            img {
              width: 28px;
              margin-bottom: 8px;
            }
          }
        }
      }

      .topTitle {
        line-height: 44px;
        background: #fff;
        padding: 0 16px;
        border-bottom: 1px solid #f5f5f5;
        .title{
          font-weight: bold;
        }
        .toCont {
          color: #8D95A6;
        }
      }

    }

    .banner {
      img {
        width: 100%;
      }
    }

    .van-search__action {
      color: #fff;
      padding: 0 0.2rem;
      margin: 0 0.3rem;
      margin-left: 0.5rem;
      font-size: 0.5rem;
    }

    .van-search__action:active {
      background: none;
    }

    .van-search__content--round {
      padding: 0 15px;
    }

  }

</style>
<style lang="less">
  .home {
    .van-field__left-icon {
      display: none !important;
    }
  }

</style>

